import React from "react";
import { Phone, Mail, Clock, MapPin } from "lucide-react";
import { BUSINESS } from "@/lib/api";

const TopBar = () => {
  return (
    <div className="bg-[#0F0F0F] text-white text-sm" data-testid="top-bar">
      <div className="max-w-7xl mx-auto px-4 py-2.5 flex flex-wrap items-center justify-between gap-y-2 gap-x-6">
        <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
          <a
            href={BUSINESS.phoneHref}
            className="flex items-center gap-2 hover:text-[#E50914] transition-colors"
            data-testid="topbar-phone"
          >
            <Phone className="w-4 h-4 text-[#E50914]" />
            <span className="font-medium">{BUSINESS.phone}</span>
          </a>
          <a
            href={BUSINESS.emailHref}
            className="hidden sm:flex items-center gap-2 hover:text-[#E50914] transition-colors"
            data-testid="topbar-email"
          >
            <Mail className="w-4 h-4 text-[#E50914]" />
            <span>{BUSINESS.email}</span>
          </a>
        </div>
        <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
          <div className="hidden md:flex items-center gap-2">
            <Clock className="w-4 h-4 text-[#E50914]" />
            <span className="opacity-90">{BUSINESS.hours}</span>
          </div>
          <div className="hidden lg:flex items-center gap-2">
            <MapPin className="w-4 h-4 text-[#E50914]" />
            <span className="opacity-90">Surrey, BC</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
